import _ from 'lodash';

export const isValid = (value: unknown): boolean => {
    if (_.isBoolean(value)) {
        return value;
    }
    if (_.isNumber(value)) {
        return true;
    }
    return !_.isNil(value) && !_.isEmpty(value);
};
